/**
 * To be called from OnDestroy.
 * @param subscriptions
 */
import { Subscription } from 'rxjs';

export function unsubscribeFromAll(subscriptions: Subscription[]): void {
  subscriptions.forEach((subscription) => {
    if (subscription) {
      subscription.unsubscribe();
    }
  });
}
